





































import { Vue, Component } from "vue-property-decorator"

const AppProps = Vue.extend({
	props: {
	}
})

@Component({})
export default class FormTagList extends AppProps {
	value = []

	updateTags(tags: string[]) {
		this.$store.dispatch("setCreateTags", tags)
	}

	get availableOptions() {
		return this.$store.state.tags
	}
}
